// extracted by mini-css-extract-plugin
export default {"wrapperComponent":"WorkInProgress_wrapperComponent__T6nqf"};